import styled, { css } from "styled-components";

import { Modal } from "@braze/beacon-core";
import type { ModalProps } from "@braze/beacon-core";
import { getSpacing } from "@braze/beacon-styling";

const operatorButtonSizePx = 32;
const modalCloseIconSizePx = 24;

// Operator button is 32px; modal close icon is 24px. Shift up by half the difference to vertically center them.
const operatorButtonTopOffsetPx = (operatorButtonSizePx - modalCloseIconSizePx) / 2;

export const operatorModalStyles = css`
  .bcl-modal-backdrop,
  .bcl-modal-dialog {
    right: var(--operator-inline-width, 0px);
    width: calc(100vw - var(--operator-inline-width, 0px));
  }
`;

export const StyledBrazeModal = styled(Modal)`
  ${operatorModalStyles}
`;

const isLargeModal = (size?: ModalProps["size"]) => {
  return size === "md" || size === "lg" || size === "xl";
};

const topOperatorButtonOffset = (isLarge: boolean) => css`
  top: calc(${isLarge ? getSpacing("xl") : getSpacing("lg")} - ${operatorButtonTopOffsetPx}px);
`;

const rightOperatorButtonOffset = (isLarge: boolean, offsetForCloseIcon: boolean) => css`
  right: ${offsetForCloseIcon
    ? css`
        calc(${isLarge ? getSpacing("xl") : getSpacing("lg")} + ${modalCloseIconSizePx}px + ${getSpacing("md")})
      `
    : isLarge
      ? getSpacing("xl")
      : getSpacing("lg")};
`;

export const StyledOperatorLaunchButtonWrapper = styled.div<{
  $size?: ModalProps["size"];
  $offsetForCloseIcon: boolean;
}>`
  position: absolute;

  ${({ $size, $offsetForCloseIcon }) => {
    const isLarge = isLargeModal($size);

    return css`
      ${topOperatorButtonOffset(isLarge)}
      ${rightOperatorButtonOffset(isLarge, $offsetForCloseIcon)}
    `;
  }}

  & .db-braze-operator-launch-button {
    width: ${operatorButtonSizePx}px;
    height: ${operatorButtonSizePx}px;
  }
`;
